import React, { FunctionComponent } from "react";
import styles from "./ProgressIndicator.module.scss";
import cn from "classnames";

const ProgressIndicator: FunctionComponent<{ numberOfProjects: number }> = ({
  numberOfProjects,
}) => {
  return (
    <>
      <div className={styles.ProgressIndicator_level}>
        {numberOfProjects} / 8
      </div>

      <div className={styles.ProgressIndicator}>
        {[0, 1, 2, 3, 4, 5, 6, 7].map((number) =>
          number + 1 <= numberOfProjects ? (
            <div
              key={number}
              className={cn(styles.ProgressIndicator_bar, {
                [styles.ProgressIndicator_bar__purple]: numberOfProjects < 4,
                [styles.ProgressIndicator_bar__blue]: numberOfProjects >= 4,
                [styles.ProgressIndicator_bar__green]: numberOfProjects === 8,
              })}
            />
          ) : (
            <div key={number} className={styles.ProgressIndicator_bar} />
          )
        )}
      </div>
    </>
  );
};

export default ProgressIndicator;
